




























































import Vue from 'vue';
export default Vue.extend({
  name: 'TextCard',
  props: {
    heading: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'Centered',
    },
    actions: {
      type: Object as () => any,
      default: () => {
        return {};
      },
    },
    secondaryAction: {
      type: Object as () => any,
      default: () => {
        return {};
      },
    },
    image: {
      type: Object as () => any,
    },
  },
  methods: {
    isRoute(action): boolean {
      return action ? action.indexOf('route="') > -1 : false;
    },
    isLink(action): boolean {
      return action ? action.indexOf('link="') > -1 : false;
    },
    isSelfLink(action): boolean {
      return action ? action.indexOf('link:self="') > -1 : false;
    },
    constructRoute(action): string {
      let regex;
      if (this.isRoute(action)) {
        regex = /(route=")(.*)(")/g;
      } else if (this.isLink(action)) {
        regex = /(link=")(.*)(")/g;
      } else if (this.isSelfLink(action)) {
        regex = /(link:self=")(.*)(")/g;
      }
      return action.replace(regex, (match, a, b) => {
        return b;
      });
    },
  },
  computed: {
    cardImage(): string {
      return this.image
        ? this.image.fields.file.url
        : '@/capblue-branding-module/static/home-banner.jpg';
    },
    cardAlt(): string {
      return this.image ? this.image.fields.description : 'String Lights';
    },
  },
});
